import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { SelectAll } from '../../../_config/constants/select-all.constant';
import { GetAllPharmacies } from '../../../_config/utils/get-all-pharmacies.util';
import CustomCard from '../../../v2-components/Antd/Card';
import CustomSearch from '../../../v2-components/Antd/Search';
import Pharmacies from '../../../v2-components/Pharmacies';
import { Service } from '../service';
import PharmacyLocalsListTable from './components/ListView';
import { mapOptions } from './handle/map-options.handle';
import { handleSearchParams } from './handle/search-params.handle';
import './style.scss';
import Loading from '../../../v2-components/Loading';

export default function AdminPharmacyLocalsListPage() {
	const history = useHistory();
	const location = useLocation();
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const [data, setData] = useState();
	const searchParams = new URLSearchParams(location?.search);
	const paramPage = searchParams.get('page') || 1;
	const nameLocalQueryParam = searchParams.get('name_local');
	const pharmacyQueryParam = searchParams.get('pharmacy');
	const [nameLocal, setNameLocal] = useState(nameLocalQueryParam);
	const [nameLocalSearchText, setNameLocalSearchText] = useState('');
	const [pharmacy, setPharmacy] = useState(pharmacyQueryParam);
	const [pharmaciesList, setPharmaciesList] = useState();

	const dataSource = data?.data;
	const pagination = {
		currentPage: data?.currentPage,
		pageSize: data?.itemsPerPage,
		totalItems: data?.totalItems,
	};

	useEffect(() => {
		Promise.all([new Service().getAll( paramPage, nameLocal, pharmacy ), new Service().getPharmacies()])
			.then(([localsResponse, pharmaciesResponse]) => {
				setData(localsResponse);
				setPharmaciesList([SelectAll[Enviroment.LANGUAGE], ...mapOptions(pharmaciesResponse?.data)]);
				setLoading(false);
			})
			.catch((error) => {
				setError(true);
				console.log('error response: ', error);
			});
	}, [paramPage, nameLocal, pharmacy]);

	const handlePageChange = (page) => {
		searchParams.set('page', page);
		const newSearchParmas = searchParams.toString();
		history.push({
			pathname: location?.pathname,
			search: newSearchParmas,
		});
	};

	const handleSearchValueChange = (e) => {
		setNameLocalSearchText(e.target.value);
	};

	const handleSelectChange = (value) => {
		GetAllPharmacies(value, setPharmacy);
		searchParams.set('pharmacy', value);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleSearch = (nameLocal) => {
		searchParams.set('page', 1);
		searchParams.set('name_local', nameLocal);
		setNameLocal(nameLocal);
		if (!nameLocal) {
			searchParams.delete('name_local');
			setNameLocal(null);
		}
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	if (loading) {
		return <Loading />;
	}

	return (
		<Row justify={'center'} className="own-pharmacy-locals-list-page-admin">
			<Col span={22}>
				<h1>Sucursales</h1>
				<CustomCard className="own-card-container-admin">
					<h2>Farmacias y sucursales</h2>
					<Row justify={'space-between'}>
						<Pharmacies style={{ width: '30%', marginBottom:'10px' }} onChange={handleSelectChange} options={pharmaciesList} />
						<Col span={10}>
							<CustomSearch
								className="own-search-pharmacy-admin"
								placeholder={'Buscar por nombre'}
								onChange={handleSearchValueChange}
								onSearch={() => handleSearch(nameLocalSearchText)}
							/>
						</Col>
					</Row>

					<PharmacyLocalsListTable
						onPageChange={handlePageChange}
						dataSource={dataSource}
						pagination={pagination}
						loading={loading}
						error={error}
					/>
				</CustomCard>
			</Col>
		</Row>
	);
}
